export default function ListWrapper({
  children,
  items,
}: {
  children: React.ReactNode;
  items: Array<unknown> | undefined;
}) {
  if (!items || items.length === 0) {
    return (
      <div className="text-center text-gray-500 dark:text-zinc-400">
        No items found
      </div>
    );
  }

  return children;
}
